export default __webpack_public_path__ + "static/media/vsq-logo-vectorBASEWhiteLogo@0.5x.32f4bd7b.png";